import script from "./Consent.vue?vue&type=script&setup=true&lang=js"
export * from "./Consent.vue?vue&type=script&setup=true&lang=js"

import "./Consent.vue?vue&type=style&index=0&id=410d8422&scoped=true&lang=css"

import exportComponent from "E:\\back-to-class-master\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410d8422"]])

export default __exports__